import axios from 'axios';

export default {
    getScheme (scheme, success, fail) {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') {
            return axios.get('/dummy-scheme.json').then((response) => {
                success(response.data);
                return response.data;
            }, (response) => {
                fail(response);
            });
        }
        axios.get('/api/scheme/' + scheme).then((response) => {
            success(response.data);
        }, (response) => {
            fail(response);
        });
    },
    watchedIntroVideo () {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return Promise.resolve({ data: true });
        return axios.put('/api/scheme/');
    },
    requestAdvice () {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return Promise.resolve({ data: true });
        return axios.post('/api/wpsa');
    },
    getCanRequestAdvice () {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return Promise.resolve({ data: true });
        return axios.get('/api/wpsa');
    }
};
